// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import IFrame from "@store/Library/Components/Foundation/IFrame";
import * as React from "react";

interface OwnProps extends WidgetProps {
    extendedStyles?: EmbededVideoStyles;
    fields: {
        [fields.videoLink]: string;
    };
}

export interface EmbededVideoStyles {
    videoGridItem?: GridItemProps;
}

const enum fields {
    videoLink = "videoLink",
}

export const embededVideoStyles: EmbededVideoStyles = {
    videoGridItem: {
        width: [12, 12, 12, 12, 12],
    },
};

const EmbededVideoWidget: React.FC<OwnProps> = ({ fields, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(embededVideoStyles, extendedStyles));

    return (
        <GridItem {...styles.videoGridItem}>
            <IFrame src={fields.videoLink} />
        </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: EmbededVideoWidget,
    definition: {
        group: "Common",
        displayName: "Embeded Content Video",
        fieldDefinitions: [
            {
                name: fields.videoLink,
                displayName: "Video Link",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
